
import React from 'react';
import { Form, Col} from 'react-bootstrap';
import {  getIn } from 'formik';
import InputDateFormat from '../../InputDateFormat';
import NumberFormat from '../../NumberFormat';


export default class Income extends React.Component {
    constructor(props) {
        super(props);
        this.state={ 
            whom:'client'
        }
    }
     render(){
        return(
                <Form.Row>
                    <Form.Group as={Col} md="6" controlId="validationFormikgrossMonthlySalary">
                        <Form.Label className="required">Gross <strong>Monthly</strong> Salary</Form.Label>
                        <NumberFormat
                            value={getIn(this.props.values, `${this.props.type}.grossMonthlySalary`)}  
                            thousandSeparator={true} 
                            prefix={'$'} 
                            onValueChange={e => { 
                                this.props.setFieldValue( `${this.props.type}.grossMonthlySalary`, e.floatValue);
                                this.props.setFieldTouched( `${this.props.type}.grossMonthlySalary`,true);  }}
                            error={getIn(this.props.errors, `${this.props.type}.grossMonthlySalary`) }
                            />
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="validationFormikgrossMonthlySalary">
                        <Form.Label className="required">Retirement Date</Form.Label>
                        {/* <Field
                            component={DatePicker}
                                name={`${this.props.type}.retirementDate`}
                                dayPlaceholder={'dd'}
                                monthPlaceholder={'mm'}
                                yearPlaceholder={'yyyy'}
                                minDate= {new Date()}
                                maxDetail={'year'}
                                showLeadingZeros ={false}
                                clearIcon={null}
                                onChange={e => { 
                                    this.props.setFieldValue(`${this.props.type}.retirementDate`, e);this.props.setFieldTouched(`${this.props.type}.retirementDate`,true);} }
                                error={getIn(this.props.errors, `${this.props.type}.retirementDate`) }
                                value={getIn(this.props.values, `${this.props.type}.retirementDate`) }
                                touched={this.props.setFieldTouched }
                                /> */}
                        <InputDateFormat
                            inputvalue={getIn(this.props.values, `${this.props.type}.retirementDate`) } 
                            name={`${this.props.type}.retirementDate`}
                            placeholder={"mm/yyyy"}
                            mindate={new Date()}
                            maxdate={new Date(2099,11,31)}
                            disableday={"true"}
                            onValueChange={e => { 
                                this.props.setFieldValue( `${this.props.type}.retirementDate`, e.formattedValue);
                                this.props.setFieldTouched( `${this.props.type}.retirementDate`,true);  }}
                            error={getIn(this.props.errors, `${this.props.type}.retirementDate`) }
                            />
                    </Form.Group>
                </Form.Row>
        );
    }
}